<template>
  <div class="mobile-navbar-wrapper">
    <div class="navbar-container">
      <div v-for="(navbar, index) in filteredNavbarData" :key="index">
        <!-- Dropdown Section -->
        <div
          v-if="navbar.dropdown && navbar.dropdown.length > 0"
          class="dropdown-section"
        >
          <div class="section-header">
            <h3 class="section-title">{{ navbar.title }}</h3>
            <div class="section-divider"></div>
          </div>
          <div class="dropdown-items-grid">
            <div
              v-for="(dropdownItem, dropdownIndex) in navbar.dropdown"
              :key="dropdownIndex"
              class="nav-card-wrapper"
            >
              <router-link
                :to="{ name: dropdownItem.name }"
                class="nav-card"
                :class="{
                  'nav-card-active': $route.name === dropdownItem.name,
                }"
              >
                <div class="nav-card-icon-container">
                  <i :class="dropdownItem.icon" class="nav-card-icon"></i>
                  </div>
                <span class="nav-card-label">{{ dropdownItem.title }}</span>
                <div class="nav-card-ripple"></div>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Regular Nav Item -->
        <div v-else-if="!navbar.dropdown" class="nav-card-wrapper">
              <router-link
                  :to="{ name: navbar.name }"
            class="nav-card"
            :class="{ 'nav-card-active': $route.name.includes(navbar.slug) }"
                > 
            <div class="nav-card-icon-container">
              <i :class="navbar.icon" class="nav-card-icon"></i>
                  </div>
            <span class="nav-card-label">{{ navbar.title }}</span>
            <div class="nav-card-ripple"></div>
              </router-link>
            </div>
          </div>

      <!-- Debug: Show if no items found -->
      <div v-if="filteredNavbarData.length === 0" class="no-items-message">
        <p>
          No mobile menu items found. Please check the navbar data
          configuration.
        </p>
      </div>
    </div>
  </div>
</template>
 
<script>
import navbar from "../../data/navbar/index.json";
export default {
  data() {
    return {
      navbarData: navbar,
    };
  },
  computed: {
    filteredNavbarData() {
      // Filter items where mobile is true (handles both boolean and string)
      const filtered = this.navbarData.filter((p) => {
        return p.mobile === true || p.mobile === "true" || p.mobile === 1;
      });

      return filtered;
    },
  },
  methods: {
    createRipple(event) {
      const button = event.currentTarget;
      const ripple = button.querySelector(".nav-card-ripple");

      if (ripple) {
        const rect = button.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = event.clientX - rect.left - size / 2;
        const y = event.clientY - rect.top - size / 2;

        ripple.style.width = ripple.style.height = size + "px";
        ripple.style.left = x + "px";
        ripple.style.top = y + "px";
        ripple.style.transform = "scale(0)";
        ripple.style.opacity = "1";

        // Remove previous animation class
        ripple.classList.remove("ripple-active");

        // Trigger reflow
        void ripple.offsetWidth;

        // Add animation class
        ripple.classList.add("ripple-active");

        // Clean up after animation
        setTimeout(() => {
          ripple.classList.remove("ripple-active");
          ripple.style.transform = "scale(0)";
          ripple.style.opacity = "1";
        }, 600);
      }
    },
  },
  mounted() {
    // Add click event listeners for ripple effect
    this.$nextTick(() => {
      const cards = this.$el.querySelectorAll(".nav-card");
      cards.forEach((card) => {
        card.addEventListener("click", this.createRipple);
      });
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    const cards = this.$el.querySelectorAll(".nav-card");
    cards.forEach((card) => {
      card.removeEventListener("click", this.createRipple);
    });
  },
};
</script>
<style scoped>
/* Main Container */
.mobile-navbar-wrapper {
  padding: 2.5rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  background-attachment: fixed;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.mobile-navbar-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.navbar-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 1.5rem;
  align-items: start;
  position: relative;
  z-index: 1;
}

/* Dropdown Section */
.dropdown-section {
  grid-column: 1 / -1;
  width: 100%;
  margin-bottom: 2rem;
}

.section-header {
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 0.75rem 0;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.section-divider {
  height: 4px;
  width: 80px;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.5) 100%);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
}

.dropdown-items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1.25rem;
}

/* Nav Card */
.nav-card-wrapper {
  position: relative;
  width: 100%;
}

.nav-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 24px;
  text-decoration: none;
  color: #2d3748;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  overflow: hidden;
  min-height: 140px;
  cursor: pointer;
}

.nav-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  opacity: 0;
  transition: opacity 0.5s ease;
  z-index: 0;
}

.nav-card::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.3) 0%,
    transparent 70%
  );
  opacity: 0;
  transition: opacity 0.5s ease;
  z-index: 1;
}

.nav-card:hover {
  transform: translateY(-12px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.4),
    0 10px 20px rgba(118, 75, 162, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.8);
  color: #667eea;
}

.nav-card:hover::before {
  opacity: 0.1;
}

.nav-card:hover::after {
  opacity: 1;
}

.nav-card-active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: rgba(255, 255, 255, 0.4);
  color: #ffffff;
  box-shadow: 0 20px 40px rgba(102, 126, 234, 0.5),
    0 10px 20px rgba(118, 75, 162, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.nav-card-active::before {
  opacity: 1;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
}

.nav-card-active::after {
  opacity: 0.5;
}

.nav-card-active:hover {
  transform: translateY(-12px) scale(1.05);
  color: #ffffff;
  box-shadow: 0 25px 50px rgba(102, 126, 234, 0.6),
    0 15px 30px rgba(118, 75, 162, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

/* Icon Container */
.nav-card-icon-container {
  position: relative;
  z-index: 2;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.15) 0%,
    rgba(118, 75, 162, 0.15) 100%
  );
  border-radius: 20px;
  margin-bottom: 1rem;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.nav-card:hover .nav-card-icon-container {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.25) 0%,
    rgba(118, 75, 162, 0.25) 100%
  );
  transform: scale(1.15) rotate(8deg);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.nav-card-active .nav-card-icon-container {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.nav-card-active:hover .nav-card-icon-container {
  transform: scale(1.15) rotate(-8deg);
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}

.nav-card-icon {
  font-size: 2.25rem;
  color: #667eea;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 2px 4px rgba(102, 126, 234, 0.2));
}

.nav-card:hover .nav-card-icon {
  color: #667eea;
  transform: scale(1.15);
  filter: drop-shadow(0 4px 8px rgba(102, 126, 234, 0.4));
}

.nav-card-active .nav-card-icon {
  color: #ffffff;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.nav-card-active:hover .nav-card-icon {
  color: #ffffff;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

/* Label */
.nav-card-label {
  position: relative;
  z-index: 2;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.4;
  transition: all 0.4s ease;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.nav-card:hover .nav-card-label {
  transform: translateY(-2px);
}

.nav-card-active .nav-card-label {
  color: #ffffff;
  font-weight: 800;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.nav-card-active:hover .nav-card-label {
  transform: translateY(-2px);
}

/* Ripple Effect */
.nav-card-ripple {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(102, 126, 234, 0.3) 100%
  );
  transform: scale(0);
  opacity: 1;
  pointer-events: none;
  z-index: 1;
  transition: transform 0.6s ease-out, opacity 0.6s ease-out;
}

.nav-card-ripple.ripple-active {
  animation: ripple 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    transform: scale(5);
    opacity: 0;
  }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .navbar-container {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 1.25rem;
  }

  .dropdown-items-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .mobile-navbar-wrapper {
    padding: 2rem 1rem;
  }

  .navbar-container {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 1rem;
  }

  .dropdown-items-grid {
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    gap: 0.875rem;
  }

  .nav-card {
    padding: 1.5rem 1rem;
    min-height: 120px;
    border-radius: 16px;
  }

  .nav-card-icon-container {
    width: 64px;
    height: 64px;
    border-radius: 18px;
    margin-bottom: 0.875rem;
  }

  .nav-card-icon {
    font-size: 2rem;
  }

  .nav-card-label {
    font-size: 0.875rem;
  }

  .section-title {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .mobile-navbar-wrapper {
    padding: 1.5rem 0.75rem;
  }

  .navbar-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.875rem;
  }

  .dropdown-items-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .nav-card {
    padding: 1.25rem 0.75rem;
    min-height: 110px;
    border-radius: 14px;
  }

  .nav-card-icon-container {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    margin-bottom: 0.75rem;
  }

  .nav-card-icon {
    font-size: 1.75rem;
  }

  .nav-card-label {
    font-size: 0.8125rem;
  }

  .section-title {
    font-size: 1.125rem;
  }

  .section-divider {
    width: 50px;
    height: 2px;
  }
}

/* Loading Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.nav-card-wrapper {
  animation: fadeInUp 0.5s ease-out;
  animation-fill-mode: both;
}

.nav-card-wrapper:nth-child(1) {
  animation-delay: 0.05s;
}
.nav-card-wrapper:nth-child(2) {
  animation-delay: 0.1s;
}
.nav-card-wrapper:nth-child(3) {
  animation-delay: 0.15s;
}
.nav-card-wrapper:nth-child(4) {
  animation-delay: 0.2s;
}
.nav-card-wrapper:nth-child(5) {
  animation-delay: 0.25s;
}
.nav-card-wrapper:nth-child(6) {
  animation-delay: 0.3s;
}
.nav-card-wrapper:nth-child(7) {
  animation-delay: 0.35s;
}
.nav-card-wrapper:nth-child(8) {
  animation-delay: 0.4s;
}

/* Smooth Scroll */
.mobile-navbar-wrapper {
  scroll-behavior: smooth;
}

/* Focus States for Accessibility */
.nav-card:focus {
  outline: 3px solid rgba(102, 126, 234, 0.5);
  outline-offset: 2px;
}

.nav-card:focus:not(:focus-visible) {
  outline: none;
}

/* No Items Message */
.no-items-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem 2rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  color: #4a5568;
  font-size: 1.125rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.no-items-message p {
  margin: 0;
  font-weight: 500;
}
</style>
